import createLucideIcon from '../createLucideIcon';

const Anchor = createLucideIcon('Anchor', [
  ['circle', { cx: '12', cy: '5', r: '3', key: 'rqqgnr' }],
  ['line', { x1: '12', x2: '12', y1: '22', y2: '8', key: 'abakz7' }],
  ['path', { d: 'M5 12H2a10 10 0 0 0 20 0h-3', key: '1hv3nh' }],
]);

export default Anchor;
